/* Keep the product size table in sync with radio and select variant choices. */
(function(){
'use strict';
if(window.STHSizeMeaningReady)return;
window.STHSizeMeaningReady=true;
const norm=v=>String(v||'').trim().toLowerCase().replace(/[–—−]/g,'-').replace(/\s+/g,'').replace(/(\d)to(\d)/g,'$1-$2').replace(/months?/g,'m').replace(/years?/g,'y');
function selected(picker,name){
  const fields=picker.querySelectorAll('fieldset.sth-size-option,fieldset.variant-option');
  for(const f of fields){const label=norm(f.querySelector('.sth-option-title, legend')?.textContent);if(name&&label&&!label.includes(name)&&!name.includes(label))continue;const el=f.querySelector('input[type=radio]:checked');if(el)return el.value;}
  for(const s of picker.querySelectorAll('select')){const label=norm((s.name||'')+' '+(s.closest('.variant-option')?.querySelector('label')?.textContent||''));if(name&&label&&!label.includes(name))continue;if(s.value)return s.value;}
  return picker.querySelector('fieldset.sth-size-option input[type=radio]:checked')?.value||'';
}
function mark(){
 document.querySelectorAll('[data-sth-product-size-guide]').forEach(guide=>{
  const picker=guide.closest('variant-picker');if(!picker)return;
  const wanted=norm(guide.dataset.sizeOptionName||'');
  const val=norm(selected(picker,wanted));
  guide.querySelectorAll('[data-sth-size-row]').forEach(row=>{
   const rowValue=norm(row.dataset.sthSizeRow);
   const match=!!val&&(rowValue===val||rowValue.replace(/cm$/,'')===val.replace(/cm$/,''));
   row.classList.toggle('sth-size-meaning__selected',match);
   row.setAttribute('aria-selected',String(match));
  });
 });
}
let timer;const run=()=>{clearTimeout(timer);timer=setTimeout(mark,75)};
document.addEventListener('change',run);
document.addEventListener('variant:selected',run);
document.addEventListener('variant:updated',run);
document.addEventListener('shopify:section:load',run);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mark,{once:true});else mark();
const root=document.querySelector('.sth-product-page');
if(root&&typeof MutationObserver!=='undefined'){const observer=new MutationObserver(run);observer.observe(root,{subtree:true,childList:true});}
})();